const translations = {
  title: 'Segmentación',
  'menu.import': 'Importar',
  'menu.importHistory': 'Historial de importación',
  'menu.export': 'Exportar',
  'menu.exportHistory': 'Historial de exportación',
  'table.name': 'Nombre',
  'table.createdAt': 'Fecha de creación',
  'table.updatedAt': 'Fecha de actualización'
}

export default translations
